import { TrackingRegion } from '../../../../common/AnalyticsContext/TrackingData';
import { ButtonVariants } from '../../../../common/components/Button/DeprecatedButtonVariants';
import { StyledLinkButton } from '../../../../common/components/Button/StyledButtons';
import { Heading } from '../../../../common/components/Typography/Heading/Heading';
import { Paragraph } from '../../../../common/components/Typography/Paragraph/Paragraph';
import { DisplayCard } from '../../../../common/components/cards/DisplayCard/DisplayCard';
import { Row } from '../../../../common/components/layout/FlexLayout';
import {
  PrescriptionSectionCol,
  PrescriptionSectionPageSection,
} from '../PrescriptionSection.styles';
import { PHIBannerSectionGraphic } from './PHIBannerSection.styles';

export const PHIBannerSection = () => (
  <PrescriptionSectionPageSection trackingRegionId={TrackingRegion.PHI}>
    <DisplayCard
      imageElement={
        <PHIBannerSectionGraphic
          src="/public/images/homepage-phi_20220224060702.png"
          htmlAttributes={{ alt: 'Dad holding his children in his arms' }}
          width={676.8}
          height={406.38}
        />
      }
    >
      <Row>
        <PrescriptionSectionCol>
          <Heading h3>All your private health insurance needs in one place</Heading>
          <Paragraph>
            Our partner Compare the Market knows the market and has done the work to look for
            products that could be a good fit for your needs and circumstances. After all, there
            should be no one-size-fits-all approach to your and your family’s health
          </Paragraph>
          <StyledLinkButton
            to="https://healthengine.com.au/services/private-health-insurance-hub?icid=hbf:hom:inc::med:::::feb22"
            variant={ButtonVariants.accent}
          >
            Find out more
          </StyledLinkButton>
        </PrescriptionSectionCol>
      </Row>
    </DisplayCard>
  </PrescriptionSectionPageSection>
);
